module.exports = __webpack_public_path__ + "img/20200110155935644.1dda6b11.jpg";